import { Map } from 'immutable';

export const PHONE_STATUS = {
  VALID: 'VALID',
  INVALID: 'INVALID',
  NOT_FETCHED: 'NOT_FETCHED'
};

const GET_SMS = 'GET_SMS';
const SEND_SMS = 'SEND_SMS';
const CLEAR_SMS = 'CLEAR_SMS';

export default (state = { data: Map(), validPhone: PHONE_STATUS.NOT_FETCHED }, action) => {
  switch (action.type) {
    case SEND_SMS:
      if (action.payload.status) {
        return {
          data: Map(action.payload.data),
          validPhone: PHONE_STATUS.VALID
        };
      } else {
        return {
          data: Map(),
          // data: action.payload.data,
          validPhone: PHONE_STATUS.INVALID,
        }
      }

    case CLEAR_SMS:
      return {
        data: Map(),
        validPhone: PHONE_STATUS.NOT_FETCHED
      };
    default:
      return state;
  }
}

export const getSms = (phone) => ({
  type: GET_SMS,
  payload: phone
})

export const sendSms = (data, status) => ({
  type: SEND_SMS,
  payload: { data, status }
})

export const clearSms = () => ({
  type: CLEAR_SMS
})


// WEBPACK FOOTER //
// ./src/reducers/sendSmsStatus.js